export default {
  '请输入手机号/邮箱': 'Enter e-mail Address',
  '请输入手机号/邮箱/子账号': 'Please enter your e-mail/login account',
  获取验证码: 'Get Verification Code',
  请输入验证码: 'Enter Verification Code',
  请输入密码: 'Enter Password',
  '请设置密码（6-18位）': 'Set Password (6-18 Characters).',
  '请输入密码（6-18位）': 'Enter Password (6-18 Characters).',
  请再次确认密码: 'Repeat Password.',
  勾选表示您同意并愿意遵守云展动力平台以下协议政策:
    'by checking here you agree to and will abide by the following terms and policies of this website.',
  我已有账户: 'I already have an account',
  请阅读勾选协议: 'Please Read and Agree to our terms and conditions.',
  请输入至少6个字符: 'Please enter at least 12 characters.',
  不能超过18位字符: 'No more than 36 characters!',
  请输入手机号码或邮箱: 'Please enter phone number or E-mail address.',
  '请输入正确的手机号码或邮箱！': 'Please enter the correct phone number or E-mail address.',
  '密码强度不够,不能纯数字或者纯字母': 'Your password is not strong enough. It must contain both numbers and letters.',
  请再次输入密码: 'Please enter the password again.',
  两次密码不一致: 'Two passwords don’t match.',
  密码修改成功: 'Password reset successfully!',
  验证码发送中: 'Sending...',
  '验证码发送成功,请注意查看': 'Verification code sent successfully. Please check your mobile or e-mail.',
  强度: 'Strength',
  输入密码温馨提示: 'Please enter at least 6 characters. Please avoid using easy-to-guess passwords.',
  云展动力平台服务协议: 'Service Agreement of Cloud Exhibition',
  法律声明与隐私权政策: 'Legal Notice and Privacy Policy',
  版权政策与法律说明: 'Copyright Policy and Legal Notice',
  注册成功: 'Registration Successful!',
  恭喜您成为了: 'Congratulations, you are now a ',
  采购商: 'Buyer',
  参观采购商: 'Buyer',
  参观商可以免费在平台获取最新最热的全球展览:
    'Buyers can enjoy free access to global exhibitions, industry news, and event live streams, meet quality suppliers and place orders online. You can also apply for other roles to enjoy more value-added services:',
  参与云上展览会议等:
    'Join in virtual events, watch event live streams, showcase new products, and meet worldwide buyers.',
  点击申请入驻: 'Verify Now',
  发布展览会议视频直播: 'Post your events and upload event videos, photos, and floor plans.',
  为展览提供各种专业承包服务: 'Provide various professional contracting services.',
  低: 'Weak',
  中: 'Average',
  强: 'Strong',
  该账号已注册: 'This account already exists.',
  获取会员信息失败: 'Unable to retrieve user info.',
  欢迎您: 'Welcome!',
  欢迎回来: 'Welcome Back!',
  早上好: 'Good Morning!',
  中午好: 'Good Afternoon!',
  晚上好: 'Good Evening!',
}
